import { SVGProps } from 'react';

export const ArrowRightIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={9}
      height={13}
      viewBox="0 0 9 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.661388 12.2359C0.465508 12.0667 0.355469 11.8373 0.355469 11.598C0.355469 11.3588 0.465508 11.1294 0.661388 10.9602L5.83341 6.49455L0.661388 2.02889C0.471059 1.85874 0.365744 1.63086 0.368124 1.39431C0.370505 1.15777 0.480392 0.931499 0.674116 0.764233C0.86784 0.596967 1.1299 0.50209 1.40386 0.500034C1.67782 0.497978 1.94175 0.588911 2.13881 0.753245L8.04955 5.85673C8.24543 6.02591 8.35547 6.25533 8.35547 6.49455C8.35547 6.73377 8.24543 6.9632 8.04955 7.13238L2.13881 12.2359C1.94287 12.405 1.67716 12.5 1.4001 12.5C1.12304 12.5 0.857327 12.405 0.661388 12.2359Z"
        fill="#4C4C4C"
      />
    </svg>
  );
};
